<template>
	<div>
		<div class="modal fade" id="excelModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							Importar Exame
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-12">
							<div v-if="!loading">
								<div class="flex-container">
									<label
										for="upload-xls"
										class="btn-upload-here btn btn-default btn-info"
									>
										Arquivo Excel
										<i class="fa fa-upload"></i>
									</label>

									<input
										class="upload-xls"
										type="file"
										id="upload-xls"
										name="upload-xls"
										v-on:change="handleTest($event)"
										accept=".xls,.xlsx,.ods,.csv"
									/>
								</div>

								<button
									type="button"
									class="btn-click-here btn btn-default btn-info btn-info"
								>
									<a
										href="http://wbs.viasst.com.br/new-documents/EXEMPLO_DE_EXAMES.xlsx"
										target="_blank"
									>
										Baixar o modelo
										<i class="fa fa-download"></i>
									</a>
								</button>
							</div>
						</div>
						<div v-if="loading">
							<i
								data-v-4481e0c6=""
								class="fa fa-spin fa-spinner"
							></i>
							Carregando...
						</div>

						<br />

						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

id precisa existir para poder ocorrer a criação

*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	// import "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/jszip.js";
	// import "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/xlsx.full.min.js";

	var XLSX = require('xlsx');

	let reset = {
		empresa: '',
		nome: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,
		tipoDoTeste: '',
		data: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		laboratorio: '',
		parceiro: '',
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
	};

	export default {
		name: 'ChModalVacinas',
		components: { aBox, aBtn },
		props: ['vacinasData'],
		data() {
			return {
				data: clone(reset),
				loading: false,

				vacinasData: this.vacinasData,
			};
		},
		methods: {
			async handleTest(e) {
				this.checkfile(e.target);
			},

			checkfile(sender) {
				try {
					// console.log("this.loading")
					// console.log(this.loading)

					this.loading = true;

					var validExts = new Array('.xlsx');
					var fileExt = sender.value;
					fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
					if (validExts.indexOf(fileExt) < 0) {
						alert(
							'Invalid file selected, valid files are of ' +
								validExts.toString() +
								' types.'
						);
						return false;
					} else return this.processExcel();
				} catch (e) {
					// console.log("this.loading")
					// console.log(this.loading)
				}
			},

			processExcel() {
				var fileUpload = document.getElementById('upload-xls');
				if (typeof FileReader != 'undefined') {
					var reader = new FileReader();
					//For Browsers other than IE.

					if (reader.readAsBinaryString) {
						// console.log(this)
						const readExcel = (e) => this.readExcel(e);

						reader.onload = function (e) {
							return readExcel(e.target.result);
						};

						reader.readAsBinaryString(fileUpload.files[0]);
					} else {
						//For IE Browser.
						reader.onload = function (e) {
							var data = '';
							var bytes = new Uint8Array(e.target.result);

							for (var i = 0; i < bytes.byteLength; i++) {
								data += String.fromCharCode(bytes[i]);
							}

							return this.readExcel(data);
						};
						reader.readAsArrayBuffer(fileUpload.files[0]);
					}
				} else {
					alert('This browser does not support HTML5.');
				}
			},

			readExcel(data) {
				let excelRows;
				var workbook = XLSX.read(data, {
					type: 'binary',
				});
				var firstSheet = workbook.SheetNames[0];
				excelRows = XLSX.utils.sheet_to_row_object_array(
					workbook.Sheets[firstSheet],
					{
						raw: false,
					}
				);

				const formatedRows = this.handleNormalizeData(excelRows);

				this.sendRequisitions(formatedRows);
			},

			handleNormalizeData(excelRows) {
				const normalizeBrazilianDateString = (e) =>
					this.normalizeBrazilianDateString(e);
				const handleChangeKey = (e) => this.handleChangeKey(e);
				let formatedExcelRows = [];

				excelRows.map((row) => {
					let newRow = {};

					Object.keys(row).map(function (value, label) {
						const newRowKey = handleChangeKey(value);

						let newRowValue = row[value];

						if (
							value == 'DATA_DO_RESULTADO' ||
							value == 'DATA_DO_TESTE'
						) {
							newRowValue = normalizeBrazilianDateString(
								row[value]
							);
						}

						if (
							value == 'RG/PASS' ||
							value == 'CPF' ||
							value == 'IDADE' ||
							value == 'TEMPO_DE_ANÁLISE'
						) {
							newRowValue = parseInt(row[value]);
						}

						// console.log(newRowValue)

						if (typeof newRowValue == 'string')
							newRow[newRowKey] = newRowValue.trim();
						else newRow[newRowKey] = newRowValue;
					});

					newRow.control = `${newRow.CPF} ${newRow.data}`;
					// console.log(`${newRow.CPF} ${newRow.data}`)
					// console.log(newRow.control)

					formatedExcelRows.push(newRow);
				});

				// console.log(formatedExcelRows)

				return formatedExcelRows;
			},

			// converts the keys from a the converted XLSX to JSON to php array data
			handleChangeKey(key) {
				/*
      convert this:
        "laboratório": "CTESTE"
      to this:
        data[laboratorio]: "CTESTE"
      */

				switch (key) {
					// value
					case 'CARGO':
						return 'cargo';

					case 'CPF':
						return 'CPF';

					case 'EMPRESA':
						return 'empresa';

					case 'ESTADO':
						return 'estado';

					case 'FROTA':
						return 'frota';

					case 'IDADE':
						return 'idade';

					case 'PARCEIRO':
						return 'parceiro';

					case 'NOME':
						return 'nome';

					case 'SEÇÃO':
						return 'navio';

					case 'LABORATÓRIO':
						return 'laboratorio';

					// case 'secao':
					// 	return "seção"

					case 'MUNICÍPIO':
						return 'municipio';

					case 'RG/PASS':
						return 'RG';

					// "Value of something"

					case 'DATA_DO_TESTE':
						return 'data';

					case 'TIPO_DO_TESTE':
						return 'tipo';

					default:
						return key;
				}
			},

			normalizeBrazilianDateString(date) {
				// "05/07/2022" or 5/7/2022 9:10

				function handleSetDate(index, date) {
					let baseChrt = '';
					try {
						const chrt = date.split('/')[index];

						if (chrt.length == 1) baseChrt = '0';

						return (baseChrt += chrt);
					} catch (e) {
						return '0000-00-00 00:00:00';
					}
				}

				/*
      Client chandged the way to send time

      before: 07/05/2022
      now: 7/5/22 10:20

      this alteration needed to include the new function "handleSetDateYearAndTime"
      and change the structure of the date!
      */

				function handleSetDateYearAndTime(index, date) {
					let year = '';
					let time = '';
					let baseChrtForYear = '';
					// console.log("date")
					// console.log(date)

					let uncorvertedYearAndTime = date.split('/')[index];

					uncorvertedYearAndTime = uncorvertedYearAndTime.split(' ');

					// year
					let unconvertedYear = uncorvertedYearAndTime[0];

					if (unconvertedYear.length == 2) {
						baseChrtForYear = '20';
					}

					year =
						baseChrtForYear + unconvertedYear ||
						uncorvertedYearAndTime;

					// console.log("uncorvertedYearAndTime")
					// console.log(uncorvertedYearAndTime)

					if (!uncorvertedYearAndTime[1]) {
						const time = '00:00:00';

						return { year, time };
					}
					// time
					let unconvertedTime = uncorvertedYearAndTime[1].split(':');

					let min = '';

					unconvertedTime.map((timeprop) => {
						if (timeprop.length == 1) {
							if (min.length > 1) min += ':';
							min += '0' + timeprop;
						} else {
							if (min.length > 1) min += ':';
							min += timeprop;
						}
					});

					if (min.length < 8) {
						min += ':00';
					}

					time = min;

					return { year, time };
				}

				const month = handleSetDate(0, date);
				const day = handleSetDate(1, date);
				const { year, time } = handleSetDateYearAndTime(2, date);

				const normalizedDate =
					year +
					'-' +
					('0' + month).slice(-2) +
					'-' +
					('0' + day).slice(-2) +
					' ' +
					time;
				// "2022-07-05"

				// console.log("----------------")
				// console.log("normalizedDate")
				// console.log(normalizedDate)
				// console.log("----------------")

				return normalizedDate;
				// slice is used to guarantee the 2 digits format
			},

			sendRequisitions(formatedRows) {
				this.loading = true;

				/*============================================================================================
        CHECAR SE AQUELE DADO JÁ FOI CADASTRADO! RETORNAR ERRO NO TOAST COM O ELEMENTO
      ============================================================================================*/

				WBS.send('private-custom-vacinas', formatedRows, (resp) => {
					this.loading = false;

					let duplicatasCounter = 0;
					let duplicatasLinhas = [];

					resp.data.map((isDuplicata, index) => {
						if (!isDuplicata) {
							duplicatasCounter++;
							duplicatasLinhas.push(index + 1);
						}
					});

					if (resp.status == 'success') {
						toastr.success('Registros importados com sucesso!');

						duplicatasCounter > 0 &&
							toastr.error(
								`${duplicatasCounter} registros duplicados, linhas: ${duplicatasLinhas.join(
									', '
								)}`
							);

						this.$emit('update');
						$('#excelModal').modal('hide');

						setTimeout(() => {
							window.location.reload();
						}, 6 * 1000);
					} else {
						toastr.error(resp.msgs[0]);
						// console.log(resp)
						// console.log(this.data)
					}
				});
			},

			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#excelModal').modal('show');
			},

			save() {
				/*
      WBS.send('private-save-vacinas', this.data, resp => {
        if(resp.status == 'success'){
          // toastr.success('Registro alterado com sucesso!')
          // this.$emit('update')
          // $('#excelModal').modal('hide')
        }else{
          toastr.error(resp.msgs[0])
          console.log(resp)
          console.log(this.data)
        }
      })
      */
			},

			onSelectState() {
				// console.log(this.data.estado)
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));
		},
	};
</script>

<style>
	.btn-click-here,
	.btn-upload-here {
		margin: 20px 0 !important;
		color: white !important;
		background-color: #00c0ef;
		border-color: #00acd6;

		border-radius: 3px;
		-webkit-box-shadow: none;
		box-shadow: none;
		border: 1px solid transparent;

		display: inline-block;
		padding: 6px 12px;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		border: 1px solid transparent;
		border-radius: 4px;
	}

	.btn-upload-here {
		margin-right: 20px !important;
	}

	.upload-xls::-webkit-file-upload-button,
	.upload-xls::file-selector-button {
		visibility: hidden !important;
		display: none !important;
	}

	.btn-click-here {
		margin: 20px 0 !important;
		color: white !important;
	}

	.btn-click-here a {
		color: white !important;
		text-decoration: none !important;
	}

	.flex-container {
		display: flex;
		align-items: center;
		margin-bottom: 1rem;
	}

	.fa,
	.fa-spin,
	.fa-spinner {
		overflow: visible !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/vacinas/modal2.vue